
    import { Vue, Component, Prop } from 'vue-property-decorator'
    import TwoFactorActionFooter from '@/app/settings/components/twofactor-action-footer.vue'

    @Component({
        components: {
            TwoFactorActionFooter
        }
    })
    export default class QrCodeDisplay extends Vue {
        @Prop({ type: String, default: '' }) qrCode!: string
    }
